import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function PrivacyPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const articles = [
    {
      title: '第1条（収集する情報）',
      content: ['当社は、以下の情報を取得する場合があります。'],
      bullets: [
        '氏名、メールアドレス、電話番号',
        '住所および居住国',
        '支払い情報（Stripe等の決済サービス経由）',
        '本人確認情報（必要に応じて）',
        'VAT番号（該当する場合）',
        'ペットに関する情報（種類、健康状態など）',
        'サービス利用履歴およびコミュニケーション内容',
      ],
    },
    {
      title: '第2条（利用目的）',
      content: ['取得した情報は以下の目的で利用します。'],
      bullets: [
        'サービスの提供および運営',
        '予約管理および決済処理',
        '本人確認および不正防止',
        'ユーザーサポート対応',
        'サービス改善および分析',
        '法令遵守のため',
      ],
    },
    {
      title: '第3条（法的根拠）',
      content: ['当社は、以下の法的根拠に基づき個人データを処理します。'],
      bullets: [
        '契約の履行',
        '法的義務の遵守',
        '正当な利益（サービス改善、不正防止等）',
        'ユーザーの同意（必要な場合）',
      ],
    },
    {
      title: '第4条（第三者提供）',
      content: ['当社は、以下の場合に限り個人情報を第三者に提供します。'],
      bullets: [
        '決済処理（Stripe等）',
        '法令に基づく開示要求があった場合',
        'サービス提供に必要な範囲（シッター・飼い主間）',
      ],
    },
    {
      title: '第5条（国際データ移転）',
      content: ['当社は、EU域外にデータを転送する場合、適切な保護措置（標準契約条項等）を講じます。'],
    },
    {
      title: '第6条（データ保存期間）',
      content: ['個人情報は、サービス提供および法的義務の履行に必要な期間に限り保存されます。'],
    },
    {
      title: '第7条（ユーザーの権利）',
      content: ['ユーザーは以下の権利を有します。'],
      bullets: [
        'データへのアクセス',
        '訂正または削除',
        '処理の制限',
        'データポータビリティ',
        '異議申し立て',
        '同意の撤回',
      ],
    },
    {
      title: '第8条（セキュリティ）',
      content: ['当社は、個人情報の漏洩、紛失、不正アクセスを防ぐため、適切な技術的および組織的措置を講じます。'],
    },
    {
      title: '第9条（クッキー）',
      content: ['当社は、ユーザー体験向上のためクッキーを使用する場合があります。'],
    },
    {
      title: '第10条（未成年の利用）',
      content: ['未成年者は、保護者の同意を得た上で本サービスを利用するものとします。'],
    },
    {
      title: '第11条（変更）',
      content: ['本ポリシーは必要に応じて変更される場合があります。'],
    },
    {
      title: '第12条（問い合わせ）',
      content: ['個人情報の取り扱いに関するお問い合わせは、以下までご連絡ください。'],
      email: 'support@pawbridge.com',
    },
  ];

  return (
    <div className="min-h-screen bg-[#EEF4F7]">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-[#81D8D0]/95 backdrop-blur-sm shadow-sm">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between h-24 sm:h-28">
            <Link to="/" className="flex items-center flex-shrink-0">
              <img
                src="https://static.readdy.ai/image/8518bd20f704ac7d2f3f65f4644eeb9a/37cbdfbab98dc394d9ee285d8ad1648c.svg"
                alt="PawBridge"
                className="w-40 h-40 sm:w-48 sm:h-48 object-contain brightness-0"
              />
            </Link>
            <div className="hidden md:flex items-center gap-8">
              <Link to="/sitters" className="relative text-sm text-white hover:text-white transition-colors whitespace-nowrap group">
                シッターを探す
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-white rounded-full transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link to="/sitter-registration" className="relative text-sm text-white hover:text-white transition-colors whitespace-nowrap group">
                シッター登録
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-white rounded-full transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link to="/login" className="relative text-sm text-white hover:text-white transition-colors whitespace-nowrap group">
                ログイン
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-white rounded-full transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link to="/booking" className="px-6 py-2.5 bg-white text-[#81D8D0] text-sm font-medium rounded-full hover:bg-white/90 transition-all hover:shadow-lg whitespace-nowrap">
                予約する
              </Link>
            </div>
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
            >
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
          {mobileMenuOpen && (
            <div className="md:hidden mt-4 pb-4 space-y-3">
              <Link to="/sitters" onClick={() => setMobileMenuOpen(false)} className="block text-sm text-white hover:text-white/80 transition-colors py-2">シッターを探す</Link>
              <Link to="/sitter-registration" onClick={() => setMobileMenuOpen(false)} className="block text-sm text-white hover:text-white/80 transition-colors py-2">シッター登録</Link>
              <Link to="/login" onClick={() => setMobileMenuOpen(false)} className="block text-sm text-white hover:text-white/80 transition-colors py-2">ログイン</Link>
              <Link to="/booking" onClick={() => setMobileMenuOpen(false)} className="block px-6 py-2.5 bg-white text-[#81D8D0] text-sm font-medium rounded-full hover:bg-white/90 transition-all text-center">予約する</Link>
            </div>
          )}
        </div>
      </nav>

      <div className="pt-28 sm:pt-32 pb-16">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          {/* Header */}
          <div className="mb-8 md:mb-12">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#81D8D0]/20">
                <i className="ri-shield-user-line text-xl text-[#81D8D0]"></i>
              </div>
              <h1 className="text-3xl md:text-4xl font-bold text-[#1B2A4A]">PawBridge プライバシーポリシー</h1>
            </div>
            <p className="text-xs md:text-sm text-[#1B2A4A]/50">施行日：2026年3月29日 ／ GDPR準拠</p>
          </div>

          {/* Summary cards */}
          <div className="grid sm:grid-cols-3 gap-4 mb-8">
            {[
              { icon: 'ri-lock-2-line', label: 'GDPR準拠', sub: 'EU一般データ保護規則に基づき個人情報を管理します' },
              { icon: 'ri-user-settings-line', label: 'ユーザーの権利保護', sub: 'アクセス・削除・訂正などの権利を保障します' },
              { icon: 'ri-secure-payment-line', label: '安全な決済', sub: 'Stripe等の安全な決済サービスを経由します' },
            ].map(card => (
              <div key={card.label} className="bg-[#81D8D0]/10 border border-[#81D8D0]/30 rounded-xl p-4 flex gap-3 items-start">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#81D8D0]/20 flex-shrink-0">
                  <i className={`${card.icon} text-lg text-[#81D8D0]`}></i>
                </div>
                <div>
                  <p className="text-sm font-bold text-[#1B2A4A]">{card.label}</p>
                  <p className="text-xs text-[#1B2A4A]/60 leading-relaxed mt-0.5">{card.sub}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Intro */}
          <div className="bg-white rounded-2xl px-6 py-5 mb-4 border border-[#D4E8EC]">
            <p className="text-sm md:text-base text-[#1B2A4A]/80 leading-relaxed">
              PawBridge（以下「当社」といいます）は、ユーザーの個人情報の保護を重要視し、EU一般データ保護規則（GDPR）に基づき、以下の通り個人情報の取り扱いを定めます。
            </p>
          </div>

          {/* Articles */}
          <div className="bg-white rounded-2xl p-4 md:p-8 shadow-sm space-y-6 md:space-y-8">
            {articles.map((article, i) => (
              <section key={i} className={i > 0 ? 'border-t border-[#D4E8EC] pt-6 md:pt-8' : ''}>
                <h2 className="text-xl md:text-2xl font-bold text-[#1B2A4A] mb-3 md:mb-4">{article.title}</h2>
                <div className="space-y-2 md:space-y-3 text-sm md:text-base text-[#1B2A4A]/80 leading-relaxed">
                  {article.content.map((p, j) => <p key={j}>{p}</p>)}
                  {'bullets' in article && article.bullets && (
                    <ul className="space-y-2 ml-1 mt-2">
                      {article.bullets.map((item, j) => (
                        <li key={j} className="flex items-start gap-2.5">
                          <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-[#81D8D0] mt-2"></span>
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                  {'email' in article && article.email && (
                    <div className="mt-3 flex items-center gap-2">
                      <div className="w-8 h-8 flex items-center justify-center bg-[#D4F0ED] rounded-full flex-shrink-0">
                        <i className="ri-mail-line text-[#5BC0B8] text-sm"></i>
                      </div>
                      <a
                        href={`mailto:${article.email}`}
                        className="text-[#81D8D0] font-medium hover:underline transition-colors"
                      >
                        {article.email}
                      </a>
                    </div>
                  )}
                </div>
              </section>
            ))}

            {/* Rights detail block */}
            <section className="border-t border-[#D4E8EC] pt-6 md:pt-8">
              <div className="bg-[#EEF4F7] rounded-xl p-5">
                <div className="flex items-center gap-2 mb-4">
                  <i className="ri-information-line text-[#81D8D0] text-lg"></i>
                  <p className="text-sm font-bold text-[#1B2A4A]">ユーザーの権利の行使について</p>
                </div>
                <p className="text-xs text-[#1B2A4A]/70 leading-relaxed mb-3">
                  ご自身のデータに関する権利を行使したい場合は、以下の方法でお問い合わせください。当社は原則として<strong className="text-[#1B2A4A]">30日以内</strong>に対応いたします。
                </p>
                <div className="grid sm:grid-cols-3 gap-3">
                  {[
                    { icon: 'ri-eye-line', label: 'データの確認・コピー', desc: 'アクセス権' },
                    { icon: 'ri-delete-bin-line', label: 'データの削除', desc: '削除権（忘れられる権利）' },
                    { icon: 'ri-edit-line', label: 'データの訂正', desc: '訂正権' },
                  ].map(r => (
                    <div key={r.label} className="bg-white rounded-lg p-3 flex items-center gap-3">
                      <div className="w-8 h-8 flex items-center justify-center bg-[#D4F0ED] rounded-full flex-shrink-0">
                        <i className={`${r.icon} text-[#5BC0B8] text-sm`}></i>
                      </div>
                      <div>
                        <p className="text-xs font-semibold text-[#1B2A4A]">{r.label}</p>
                        <p className="text-xs text-[#1B2A4A]/50">{r.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            {/* Addendum */}
            <section className="border-t border-[#D4E8EC] pt-6 md:pt-8">
              <div className="flex items-center gap-3 text-sm text-[#1B2A4A]/60">
                <i className="ri-calendar-check-line text-[#81D8D0] text-base"></i>
                <span>附則：本ポリシーは<strong className="text-[#1B2A4A]">2026年3月29日</strong>より施行します。</span>
              </div>
            </section>
          </div>

          <div className="mt-6 md:mt-8 flex flex-col sm:flex-row items-center justify-center gap-4 flex-wrap">
            <Link to="/" className="inline-flex items-center gap-2 text-xs md:text-sm text-[#1B2A4A]/60 hover:text-[#1B2A4A] transition-colors cursor-pointer">
              <i className="ri-arrow-left-line"></i>
              ホームに戻る
            </Link>
            <span className="hidden sm:block text-[#1B2A4A]/30">|</span>
            <Link to="/terms" className="inline-flex items-center gap-2 text-xs md:text-sm text-[#1B2A4A]/60 hover:text-[#1B2A4A] transition-colors cursor-pointer">
              利用規約を見る
              <i className="ri-arrow-right-line"></i>
            </Link>
            <span className="hidden sm:block text-[#1B2A4A]/30">|</span>
            <Link to="/contact" className="inline-flex items-center gap-2 text-xs md:text-sm text-[#1B2A4A]/60 hover:text-[#1B2A4A] transition-colors cursor-pointer">
              お問い合わせ
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-[#81D8D0] text-white pt-12 md:pt-20 pb-8 md:pb-10">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 md:gap-12 mb-8 md:mb-12">
            <div>
              <img
                src="https://static.readdy.ai/image/8518bd20f704ac7d2f3f65f4644eeb9a/37cbdfbab98dc394d9ee285d8ad1648c.svg"
                alt="PawBridge"
                className="h-28 md:h-36 mb-4 md:mb-5 brightness-0"
              />
              <p className="text-xs md:text-sm text-white/80 leading-relaxed">海外在住日本人のためのペットシッターコミュニティ</p>
            </div>
            <div>
              <h4 className="text-xs md:text-sm font-semibold uppercase mb-4 md:mb-6">サービス</h4>
              <ul className="space-y-3 md:space-y-4">
                <li><Link to="/sitters" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">シッター検索</Link></li>
                <li><Link to="/sitter-registration" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">シッター登録</Link></li>
                <li><Link to="/booking" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">料金</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-xs md:text-sm font-semibold uppercase mb-4 md:mb-6">会社情報</h4>
              <ul className="space-y-3 md:space-y-4">
                <li><Link to="/about" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">PawBridgeについて</Link></li>
                <li><Link to="/contact" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">お問い合わせ</Link></li>
                <li><Link to="/terms" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">PawBridge 利用規約</Link></li>
                <li><Link to="/sitter-terms" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">PawBridge シッター利用規約</Link></li>
                <li><Link to="/guarantee" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">PawBridge 安心保証規約</Link></li>
                <li><Link to="/privacy" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">プライバシーポリシー</Link></li>
              </ul>
            </div>
          </div>
          <div className="pt-6 md:pt-8 border-t border-white/30 text-center">
            <p className="text-xs text-white/70">© 2025 PawBridge. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}